<script>
	export let scopus_id = '';
	export let wikidata_id = '';
	const SCOPUS_URL =
		'https://www.scopus.com/inward/record.uri?partnerID=HzOxMe3b&origin=inward&scp=';
	const SCOPUS_CITATION_URL = `https://www.scopus.com/inward/citedby.uri?partnerID=HzOxMe3b&scp=85080881446&origin=inward`;
</script>

<div class="flex flex-row py-6 space-x-3">
	{#if scopus_id}
		<a
			href="{SCOPUS_URL}{scopus_id.split(/[-]+/).pop()}"
			class="px-2 py-1 text-sm font-semibold text-blue-600 rounded shadow-sm bg-indigo-50 hover:bg-indigo-100"
			>SCOPUS ID: {scopus_id.split(/[-]+/).pop()}</a
		>
	{/if}
	{#if wikidata_id}
		<a
			href="https://www.wikidata.org/wiki/{wikidata_id}"
			class="px-2 py-1 text-sm font-semibold text-indigo-600 rounded shadow-sm bg-blue-50 hover:bg-blue-100"
			>Wikidata ID: {wikidata_id}</a
		>
	{/if}
</div>
